import { Key, Entity } from '@briebug/ngrx-auto-entity';

export const springRestorationStatusMap = {
  AC: 'Active',
  CP: 'Completed',
  HD: 'Hold',
  CL: 'Cancelled',
};

@Entity({ modelName: 'SpringRestoration' })
export class SpringRestoration {
  @Key id?: string;
  status: 'AC' | 'CP' | 'HD' | 'CL';
  job: string;
  restorationType: number;
  vendor: string;
  vendorName?: string;
  vendorEmail?: string;
  jobName?: string;
  jobNumber?: string;
  length: string;
  width: string;
  depth: string;
  notes: string;
  created?: string;
  updated?: string;
}
